'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STUBBED_THREAD_ID = exports.STUBBED_THREAD_ID = 0;